/** Wrapper that times a function. */
export function maybeMeasureFunctionDuration<R>(
  fn: () => R,
  onMeasureDuration?: (duration: number, startTime: number) => void,
) {
  if (!onMeasureDuration) {
    // If we aren't given a callback, don't measure performance to reduce overhead.
    return fn();
  }

  const startTime = performance.now();
  const result = fn();
  const duration = performance.now() - startTime;
  onMeasureDuration(duration, startTime);
  return result;
}
